import { useState, useContext, useCallback } from "react";
import axios from "axios";
import { GlobalContext } from "../../Context/GlobalContext";

const useFacebookOnboarding = () => {
  const { baseUrl, basicAuth, userID } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ================= REGISTER MOBILE =================
  const registerMobileNumber = useCallback(async () => {
    try {
      const res = await axios.post(
        `${baseUrl}/Account/v1/facebookRegisterMobileNumber`,
        { userid: userID },
        {
          headers: {
            Authorization: basicAuth,
            "Content-Type": "application/json",
          },
        }
      );

      return res.data;
    } catch (err) {
      setError(err);
      return null;
    }
  }, [baseUrl, basicAuth]);

  // ================= WEBHOOK PUSH =================
  const pushWebhookData = useCallback(async (payload) => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${baseUrl}/Account/v1/facebookSignupOnboardingWebhook`,
        payload,
        {
          headers: {
            Authorization: basicAuth,
            "Content-Type": "application/json",
          },
        }
      );

      return res.data;
    } catch (err) {
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  }, [baseUrl, basicAuth]);

  return {
    loading,
    error,
    registerMobileNumber,
    pushWebhookData,
  };
};

export default useFacebookOnboarding;